export default __webpack_public_path__ + "static/media/discord-icon-lg.e6e00ed2.png";